import React from 'react'
import cx from 'classnames'

import META from '@/meta.js'
import ThemeProvider from '@/themeProvider.js'
import Footer from '@/footer.js'
import ComingSoon from '@/modules/comingSoon.js'
import EventHero from '@/heros/eventsHero.js'
import { queryEvents } from '../utls/queryEvents.js'
import PastEventsSlideshow from '@/modules/pastEventsSlideshow.js'
import UpcomingEvents from '@/modules/upcomingEvents.js';
import PastEvents from '@/modules/pastEvents.js';

const Events = ({ transitionStatus, entry, exit }) => {
  const data = queryEvents()
  const {
    previousImages
  } = data
  const metaData = {
    title: data.metaInfo ? data.metaInfo.metaTitle || 'Events - re:store' : 'Events - re:store',
    keywords: data.metaInfo ? data.metaInfo.keywords || '' : '',
    description: data.metaInfo ? data.metaInfo.description || data.description : data.description,
    url: 'events',
    image: data.image,
    ogTitle: data.metaInfo ? data.metaInfo.title || 'Events - re:store' : 'Events - re:store',
    ogDescription: data.metaInfo ? data.metaInfo.openGraphDescription || data.description : data.description,
    ogImage: data.metaInfo ? data.metaInfo.openImage || data.image : data.image,
    twitterImage: data.metaInfo ? data.metaInfo.twitterImage || data.image : data.image,
    twitterTitle: data.metaInfo ? data.metaInfo.twitterTitle || 'Events - re:store' : 'Events - re:store',
    twitterDescription: data.metaInfo ? data.metaInfo.twitterDescription || data.description : data.description
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META metaData={metaData} />
      <ThemeProvider color={`four`} />
      <div className='nav--spacer' />
      <EventHero {...data} />
      <UpcomingEvents />
      <PastEventsSlideshow events previousImages={previousImages} />
      <PastEvents />
      <ComingSoon />
      <Footer />
    </div>
  )
}

export default Events
